import httpClient from '../http-client';
import { RequestConfig } from '../types';

export function send(data: { comment: string }, config?: RequestConfig) {
  return httpClient.post<undefined>('support', data, config);
}
